import Emoji from "@core-components/emoji/Emoji";
import InfoArea from "@core-components/info-area/InfoArea";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Trans } from "react-i18next";

export const SkinSearchInfo = () => {
  const { t } = useAppTranslation("pages.skins.search");

  return (
    <InfoArea
      hasShadow
      className="xs:!p-10"
      description={
        <Trans t={t} i18nKey={"infoArea.description"}>
          Description
        </Trans>
      }
      fullWidth={false}
      headLine={
        <SSHeadline>
          <Emoji.Pin />
          <SSWhiteText> {t("infoArea.headline")}</SSWhiteText>
        </SSHeadline>
      }
    />
  );
};
